import type { Messages } from "@prop/i18n";
import type en from "../en/money";

export default {
  nav: { orders: "Заказы", payouts: "Выплаты", kyc: "Верификация", affiliate: "Партнёрам" },
  chainNames: { "tron-nile": "TRON", "ethereum-sepolia": "Ethereum" },
  chains: { "tron-nile": "USDT в тестовой сети TRON Nile", "ethereum-sepolia": "USDT в тестовой сети Ethereum Sepolia" },
  buy: {
    couponHave: "Есть купон?",
    couponChecking: "Проверяем купон…",
    couponApplied: "Купон −{amount}",
    couponRemove: "Убрать купон",
    getFree: "Получить бесплатно",
    freeNote: "Купон покрывает всю цену — платить ничего не нужно. Аккаунт откроется сразу.",
    methodFree: "Бесплатно по промокоду",
    couponRefused: {
      coupon_invalid: "Такого кода нет, или его срок закончился.",
      coupon_exhausted: "Этот код уже израсходован.",
      coupon_used: "Вы уже использовали этот код.",
      coupon_new_users_only: "Этот код только для новых трейдеров — на первую покупку.",
    },
    title: "Покупка челленджа",
    program: "Программа",
    coupon: "Купон",
    apply: "Применить",
    method: "Способ оплаты",
    card: "Карта",
    crypto: "Крипто",
    cardSoon: "Временно недоступно",
    coin: "Монета и сеть",
    feeLow: "Низкая комиссия сети",
    feeHigh: "Комиссия сети выше (газ)",
    rate: "1 {coin} ≈ {usd}",
    noCrypto: "Крипто-оплата на минуту недоступна. Попробуйте через несколько минут.",
    youGet: "Что вы получаете",
    account: "Аккаунт {program} на {size}",
    offer: "Бонус этой покупки",
    youSave: "Экономия {amount}",
    trust: {
      instant: "Аккаунт откроется сам, как только платёж подтвердится",
      rules: "Правила закреплены за аккаунтом — те, что вы видите здесь",
      split: "Доля прибыли до {pct} %",
      support: "Вопросы до оплаты? Напишите {bot} в Telegram",
    },
    consentTitle: "Начать сразу",
    couponHint: "Необязательно. Скидка будет видна на странице оплаты.",
    consentFirst: "Отметьте согласие выше, чтобы продолжить.",
    network: "Сеть",
    consent: "Прошу начать оказание услуги немедленно. Я понимаю, что теряю право на отказ после открытия аккаунта.",
    subtotal: "Цена",
    discount: "Скидка",
    total: "Итого",
    pay: "Перейти к оплате",
    rules: "Правила этой версии",
    lead: "Проверьте программу, выберите способ оплаты и подтвердите. Аккаунт работает по правилам этой версии до конца.",
    size: "Размер аккаунта",
    included: "Что входит",
    change: "Выбрать другую программу",
  },
  steps: { program: "Программа", pay: "Оплата", account: "Аккаунт" },
  checkout: {
    title: "Оплата",
    cardNumber: "Номер карты",
    testCards: "Тестовые карты — нажмите, чтобы подставить",
    cardOk: "Одобрена",
    cardDeclined: "Отказ",
    pay: "Оплатить {total}",
    declined: "Карта отклонена. Попробуйте карту 4242.",
    paid: "Оплачено. Аккаунт открывается.",
    opened: "Оплачено. Аккаунт открыт.",
    opening: "Открываем аккаунт…",
    toAccount: "Открыть аккаунт",
    sendExactly: "Отправьте ровно {amount} {token} в сети {network} на адрес:",
    expires: "Адрес действует до {at}.",
    waiting: "Ждём поступления. Страница обновится сама, как только оно подтвердится.",
    sendTitle: "Оплата в USDT",
    review: "Платёж на проверке. Аккаунт откроется, как только он подтвердится.",
    closed: "Этот заказ больше нельзя оплатить. Выберите программу, чтобы оформить новый.",
    notFound: "Заказ не найден.",
    copy: "Копировать",
    copied: "Скопировано",
    lead: "Оплатите заказ. Аккаунт откроется, как только платёж подтвердится.",
  },
  pay: {
    title: "Отправьте {token}",
    on: "в сети {network}",
    onlyNetwork: "Только в сети {network}. Монеты, отправленные в другой сети, не дойдут.",
    scan: "Отсканируйте кошельком: сеть, адрес и сумма подставятся сами",
    amount: "Сумма",
    address: "Адрес",
    memo: "Комментарий",
    memoNeed: "Добавьте этот комментарий к переводу: по нему мы узнаём, какой заказ вы оплачиваете.",
    exactly: "Отправьте ровно эту сумму. Если биржа вычитает комиссию из суммы, добавьте комиссию сверху.",
    rate: "1 {coin} = {usd} · курс зафиксирован",
    timeLeft: "осталось",
    windowClosed: "Окно оплаты закрыто. Перевод, который уже в пути, всё равно засчитается — иначе оформите новый заказ.",
    steps: { send: "Перевод", seen: "Увидели", confirm: "Подтверждён", account: "Аккаунт" },
    waiting: "Ждём ваш перевод…",
    seen: "Перевод виден · {n} из {m} подтверждений",
    final: "Перевод подтверждён · открываем аккаунт",
    underpaid: "Получено {got}. Отправьте ещё {amount} {token}, чтобы завершить, — сумма выше обновлена.",
    hashTitle: "Уже отправили? Вставьте хеш транзакции",
    hashLabel: "Хеш транзакции",
    hashCheck: "Проверить",
    hash: {
      credited: "Нашли и зачли в этот заказ.",
      confirming: "Нашли. Ждём подтверждения сети.",
      review: "Не удалось автоматически связать её с этим заказом. Наша команда проверит и откроет аккаунт, если перевод ваш.",
    },
    errors: {
      tx_not_found: "Эта транзакция (пока) не платит на наш адрес в этой сети. Проверьте сеть и хеш.",
      tx_taken: "Эта транзакция уже оплатила другой заказ.",
      chain_unavailable: "Сеть сейчас не отвечает. Попробуйте через минуту — мы всё равно следим за переводом.",
      too_soon: "Не чаще одной проверки в несколько секунд.",
      rail_busy: "Эта монета сейчас занята. Выберите другую сеть.",
      rate_unavailable: "Для этой монеты сейчас нет живого курса. Выберите другую.",
    },
    explorer: "Обозреватель",
    successTitle: "Ваш аккаунт готов",
    successLead: "Платёж подтверждён. Торгуйте челлендж по правилам, которые вы видели.",
    tradeNow: "Торговать",
    toAccount: "Об аккаунте",
    copyAmount: "Копировать сумму",
    copyAddress: "Копировать адрес",
  },
  orders: {
    title: "Заказы",
    empty: "Заказов пока нет.",
    status: { awaiting_payment: "ожидает оплаты", paid: "оплачен", provisioned: "аккаунт открыт", expired: "истёк", refunded: "возврат", chargeback: "чарджбэк", manual_review: "ручная проверка", canceled: "отменён" },
    invoice: "Счёт {n}",
    launch: "стартовая цена",
    lead: "Все купленные челленджи — со статусом и номером счёта.",
    emptyLead: "Выберите программу, чтобы купить первый челлендж.",
    buyAnother: "Купить ещё",
    toPrograms: "Выбрать программу",
    pay: "Оплатить",
    openAccount: "Аккаунт",
  },
  kyc: {
    title: "Подтверждение личности",
    why: "Нужно перед funded-аккаунтом и любой выплатой.",
    country: "Страна документа",
    countryHint: "Две буквы, например DE, GB, UZ",
    residence: "Страна проживания",
    residenceHint: "Где вы живёте сейчас, две буквы",
    region: "Область",
    regions: { other: "Другая область", ua43: "Крым", ua40: "Севастополь", ua14: "Донецкая область", ua09: "Луганская область", ua23: "Запорожская область", ua65: "Херсонская область" },
    number: "Номер документа",
    selfie: "Подтверждаю шаг с селфи",
    lockedTitle: "Верификация откроется с первой выплатой",
    lockedText: "Личность подтверждается один раз, когда это нужно: как только ваш аккаунт пройдёт оценку или funded-аккаунт дойдёт до первой выплаты. До этого здесь ничего делать не нужно.",
    lockedGo: "Ваши аккаунты",
    approvedNext: "Выплаты станут доступны, как только funded-аккаунт получит на них право.",
    pendingNote: "Заявки проверяем в течение одного рабочего дня. Страница обновится сама.",
    submit: "Отправить",
    status: { started: "начата", pending: "на проверке", approved: "подтверждена", rejected: "отклонена", retry: "попробуйте ещё раз" },
  },
  payouts: {
    title: "Выплаты",
    wallets: "Кошельки",
    addWallet: "Добавить кошелёк",
    chain: "Сеть",
    address: "Адрес",
    label: "Название",
    add: "Добавить",
    available: "доступен с {at}",
    walletStatus: { screening: "проверка", active: "активен", blocked: "заблокирован санкционной проверкой", removed: "удалён" },
    remove: "Удалить",
    removeConfirm: "Удалить насовсем?",
    keep: "Оставить",
    noWallets: "Кошельков пока нет. Добавьте адрес, на который придут выплаты.",
    addressHint: "Вставьте адрес — сеть определится по нему.",
    addressWrong: "Это не похоже на адрес {chain}.",
    walletAdded: "Кошелёк добавлен. Сначала он проходит проверку, затем доступен после задержки нового адреса.",
    sendTo: "Куда",
    needWallet: "Добавьте кошелёк, чтобы запросить эту выплату.",
    sent: "Выплата запрошена. Её статус — в истории ниже.",
    steps: {
      title: "Первая выплата в четыре шага",
      funded: "Получить funded-аккаунт",
      fundedNote: "Пройдите оценку; funded-аккаунт откроется, когда вы примете соглашение.",
      fundedGo: "Ваши аккаунты",
      kyc: "Подтвердить личность",
      kycNote: "Нужно перед любой выплатой.",
      kycGo: "Пройти проверку",
      wallet: "Добавить кошелёк",
      walletNote: "Адрес TRON или Ethereum для USDT.",
      walletGo: "Добавить кошелёк",
      request: "Запросить выплату",
      requestNote: "Когда аккаунт получит право на выплату, сумма появится выше вместе с кнопкой запроса.",
    },
    account: "Funded-аккаунт",
    noFunded: "Выплаты открываются на funded-аккаунте.",
    profit: "Прибыль",
    split: "Ваша доля",
    amount: "Вы получите",
    eligible: "Доступна",
    request: "Запросить выплату",
    next: "Ближайшая дата {at}",
    microDetail: "{share} % прибыли с последней выплаты дали сделки короче {sec} с; лимит {max} %.",
    streakDetail: "Пока {best} из {days} прибыльных дней подряд; каждый день — не меньше {bar}.",
    reasons: {
      no_rules: "В этой программе нет выплат",
      kyc: "Подтвердите личность",
      wallet: "Добавьте кошелёк и дождитесь окончания задержки нового адреса",
      open_positions: "Закройте позиции",
      first_payout_delay: "Рано для первой выплаты",
      cycle: "Цикл выплат ещё не прошёл",
      below_minimum: "Прибыль меньше минимума",
      profitable_days: "Мало прибыльных дней",
      consistency: "Один день — слишком большая доля прибыли",
      profitable_streak: "Мало прибыльных дней подряд",
      micro_scalping: "Слишком большая доля прибыли от микроскальпинга",
      min_trades: "Мало закрытых сделок",
      best_trade: "Одна сделка — слишком большая доля прибыли",
      max_payouts: "По этому счёту выплата уже была",
      window_open: "Сессия ещё идёт: выплата откроется, когда закончится время",
      window_missed: "Цель не достигнута до конца времени",
      below_fee: "Комиссия за вывод съела бы всю сумму",
    },
    history: "История",
    status: { requested: "запрошена", prepared: "ждёт подтверждения", paid: "выплачена", rejected: "отклонена", failed: "ошибка" },
    agreement: "Соглашение funded-трейдера",
    agreementText: "Примите соглашение funded-трейдера, чтобы открыть аккаунт.",
    accept: "Принять и открыть funded-аккаунт",
    lead: "Ваша доля прибыли на funded-аккаунтах: что ещё нужно выполнить, кошелёк для выплаты и сам запрос.",
    availableNow: "Можно запросить сейчас",
    cap: "Лимит этой выплаты",
    capNote: "ваша доля не больше него; бонусы ниже идут сверху",
    feeRefund: "Возврат платы",
    performanceReward: "Бонус за результат",
    haircut: "Штраф за сброс −{pct} %",
    haircutNote: "счёт сброшен после нарушения правил: каждая выплата по нему навсегда меньше на {pct} %",
    fee: "Комиссия за вывод",
    feeCell: "{base} + {pct} %",
    feeNote: "вывод в крипте; удерживается до отправки",
    feeReduced: "большинство ваших заказов оплачено криптой: 2,49 % вместо 30 %",
    net: "Вы получите",
    remainderSegment: "Прибыль сверх капа остаётся на счёте; следующая выплата считает новую прибыль от этого баланса.",
    remainderCarry: "Прибыль сверх капа остаётся на счёте, её можно вывести следующими выплатами.",
    resetNext: "Это выплата №{n}: после неё баланс вернётся к стартовому, капы снимаются.",
    resetAt: "После выплаты №{n} баланс вернётся к стартовому, затем капы снимаются.",
    funding: "Финансирование",
    fundingCell: "{funded} из {cap}",
    fundingNote: "максимум funded-капитала на одного трейдера по всем программам",
  },
  affiliate: {
    title: "Партнёрам",
    code: "Ваш код",
    link: "Ваша ссылка",
    rate: "Комиссия {pct} %, доступна через {days} дн.",
    referrals: "Приглашённые трейдеры",
    commissions: "Комиссии",
    none: "Вы пока не партнёр.",
    status: { held: "на удержании", available: "доступна", void: "аннулирована" },
    lead: "Делитесь ссылкой. Трейдеры, пришедшие по ней, считаются здесь, а комиссия становится доступной после удержания.",
  },
  admin: {
    tabs: { payments: "Платежи", payouts: "Выплаты", kyc: "KYC", coupons: "Купоны", affiliates: "Партнёры", finance: "Финансы" },
    order: "Заказ",
    customer: "Клиент",
    amount: "Сумма",
    status: "Статус",
    approvePaid: "Подтвердить оплату",
    refund: "Возврат",
    chargeback: "Записать чарджбэк",
    reason: "Причина",
    confirmDeposit: "Записать депозит",
    received: "Получено",
    confirmations: "Подтверждений",
    txHash: "Хеш транзакции",
    record: "Записать",
    prepare: "Подготовить",
    approve: "Подтвердить и отправить",
    reject: "Отклонить",
    rejectViolation: "Отклонить: нарушение правил",
    preparedBy: "подготовил {who}",
    ownPrepared: "Вы подготовили — отправляет другой сотрудник",
    hedging: "{n} встречных позиций со связанными счетами за 90 дней — проверьте «Честную торговлю» перед одобрением",
    acceptLate: "Принять опоздавший депозит",
    rail: "Сеть",
    attach: "Привязать транзакцию",
    attachHint: "Читается из сети и проверяется как любой платёж",
    transfers: "Переводы",
    unmatched: "Переводы, которые не взял ни один заказ",
    unmatchedNone: "За 30 дней таких нет.",
    claimed: "покупатель указал заказ {id}",
    attachResult: "Итог: {result}",
    decide: { approved: "Подтвердить", rejected: "Отклонить", retry: "Попросить повторить" },
    duplicate: "Тот же документ, что у {email}",
    newCoupon: "Новый купон",
    code: "Код",
    kind: "Тип",
    value: "Значение",
    maxRedemptions: "Макс. использований",
    used: "Использован",
    create: "Создать",
    newUsersOnly: "Только новым пользователям",
    turnOff: "Выключить",
    turnOn: "Включить",
    off: "выключен",
    reconciliation: "Сверка",
    providerNet: "Нетто у провайдера",
    ledgerCash: "Деньги по ledger",
    difference: "Разница",
    unbalanced: "Несбалансированных проводок: {n}",
    report: "Payout ratio по когортам",
    cohort: "Когорта",
    sales: "Продажи",
    revenue: "Выручка",
    paid: "Выплаты",
    ratio: "Доля",
    signal: "Выше 55 % — пересмотрите цены и правила",
    beta: "Бета-тестеры: воронка для цен",
    betaNote: "p_f — дошли до funded · q — funded с оплаченной выплатой · s — средняя выплата в доле размера счёта · p_f×q×s — ожидаемая выплата на $1 размера счёта, которую должна покрыть цена.",
    challenges: "Челленджи",
    funded: "Funded",
    market: "Рынок",
    newAffiliate: "Сделать пользователя партнёром",
    email: "E-mail",
  },
  bonus: {
    lockedFee: "Потом его нужно активировать: {fee}.",
    available: "Готов. Оплатите активацию — и счёт откроется.",
    availableFree: "Готов. Активируйте — и счёт откроется.",
    activate: "Активировать за {fee}",
    activateFree: "Активировать",
    confirmExtra: "Оплатить {fee} и открыть дополнительный счёт №{n} сейчас?",
    confirmReset: "Сброс бесплатный, но его нужно активировать: {fee}. Оплатить и начать оценку заново?",
    confirmResetFree: "Начать оценку заново со стартового баланса?",
    pay: "Оплатить {fee}",
    go: "Начать заново",
    cancel: "Отмена",
    resetReadyFee: "Оценка закончилась. Её можно начать заново со стартового баланса на тех же правилах. Активация: {fee}.",
    resetUse: "Использовать сброс · {fee}",
  },
} satisfies Messages<typeof en>;
